module.exports = __webpack_public_path__ + "static/media/truth-seeker-top-logos.e5481527.png";